module.exports = __webpack_public_path__ + "img/stock_plan_banner.b3eff7b0.jpg";